module.exports = __webpack_public_path__ + "static/media/Component-3.a104a059.svg";